import utils from '@/services/utils';

export default {
  getQuizData(variables = {}) {
    return utils.get('/api/home/book/get/isExistValidityBook', variables);
  },
  readBook(variables = {}) {
    return utils.get('/api/home/user/update/studentLearnBookId', variables);
  },
  getWrongBookCourses(variables = {}) {
    return utils.get('/api/home/student/user/get/projectList', variables);
  },
  getSubjectList(variables = {}) {
    return utils.get('/api/home/student/user/get/subjectList', variables);
  },
  verifyCourseListIsExist(variables = {}) {
    return utils.get('/api/home/student/book/get/isExistCourse', variables);
  },
};
